<template>
  <div>
    <v-content
      style="padding-left: 0px; padding-top: 100px; padding-right: 0px"
    >
      <section id="home">
        <Home />
      </section>

      <section id="history">
        <History />
      </section>
      <section id="services">
        <Services />
      </section>
    </v-content>
  </div>
</template>

<script>
import History from "./History";
import Home from "./Home";
import Services from "./Services";

export default {
  name: "Ems",
  components: {
    History,
    Home,
    Services,
  },
  data() {
    return { isScrolled: false };
  },

  computed: {
    isMobile() {
      return window.innerWidth <= 960; // Example breakpoint for mobile
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 0; // Check if page is scrolled
    },
  },
};
</script>





